// START IMPORTS
import { joinElements } from '@ltvco/refresh-lib/utils';

import type { Session } from '@ltvco/refresh-lib/v1';
import type { RecentReportSerialized } from '@ltvco/refresh-lib/v2';
// END IMPORTS

// START HELPER_FUNCTIONS
export function hasRunReports({ session }: { session: Session }) {
  const retentionInfo = session?.account?.account?.retention_info;
  if (retentionInfo) {
    return (
      retentionInfo.ran_email_search ||
      retentionInfo.ran_people_search ||
      retentionInfo.ran_property_search ||
      retentionInfo.ran_reverse_phone_search ||
      retentionInfo.ran_username_search ||
      retentionInfo.ran_vehicle_search
    );
  }

  return false;
}

export function generateReportSubtitle(
  report: RecentReportSerialized,
  reportType: string,
  isInDataVariation: boolean
): string {
  let subtitle = report.detailsCityState || '';

  if (report.reportType.startsWith('fam_')) {
    subtitle = joinElements(
      [report.details?.city, report.details?.state, report.details?.country],
      ', '
    );
  }

  if (reportType === 'vehicle') {
    subtitle = report.reportData;
  }

  if (reportType === 'phone') {
    if (report.firstName && report.lastName && report.detailsCityState) {
      subtitle = `${report.firstName} ${report.lastName} - ${report.detailsCityState}`;
    } else if (report.firstName && report.lastName) {
      subtitle = `${report.firstName} ${report.lastName}`;
    }
  }

  if (isInDataVariation) {
    if (reportType === 'person') {
      const address = report.details.address;
      if (address && typeof address === 'string') {
        subtitle = address;
      }
    } else if (reportType === 'contact pro' && report.details.location) {
      subtitle += `, ${report.details.location}`;
    }
  }

  return subtitle;
}
// END HELPER_FUNCTIONS
